module.exports = __webpack_public_path__ + "static/media/queen-university.bf3a7bc3.png";